// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DmUNX","body":"styles_body__KpRna","blueline":"styles_blueline__6P2XR"};